import type { TPenilaiPerencanaanMenu } from 'types/kinerja-tim-penilai-ps'

export const PERENCANAAN_STEPS_TIM_KINERJA = [
  {
    title: 'Periksa Perencanaan',
    subtitle: 'Oleh Tim Kinerja dan Pejabat Penilai Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Rekomendasi Persetujuan Perencanaan ke Pejabat Penilai Kinerja',
    subtitle: 'Oleh Tim Kinerja',
    icon: 'img-publish-data',
  },
  {
    title: 'Setujui Perencanaan',
    subtitle: 'Oleh Pejabat Penilai Kinerja',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Pengawas Sekolah',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_STEPS_PEJABAT_PENILAI_KINERJA = [
  {
    title: 'Periksa Perencanaan',
    subtitle: 'Oleh Tim Kinerja dan Pejabat Penilai Kinerja',
    icon: 'img-clip-board-summary',
  },
  {
    title: 'Setujui Perencanaan',
    subtitle: 'Oleh Pejabat Penilai Kinerja',
    icon: 'img-document-penci-fill',
  },
  {
    title: 'Tahap Pelaksanaan',
    subtitle: 'Oleh Pengawas Sekolah',
    icon: 'img-thumbs-up',
  },
]

export const PERENCANAAN_TIM_KINERJA_MENUS: TPenilaiPerencanaanMenu[] = [
  {
    key: 'not-submitted',
    title: 'Belum diajukan Pengawas Sekolah',
    subtitle: 'Kabari Pengawas Sekolah untuk segera mengajukan.',
    ctaText: 'Cek Daftar Pengawas Sekolah',
    textColor: 'default',
    subtitleColor: 'subdued',
    ctaColor: 'white',
    path: '/penilai/perencanaan/daftar-ps/belum-diajukan',
  },
  {
    key: 'submitted',
    title: 'Sudah diajukan Pengawas Sekolah',
    subtitle: 'Periksa Perencanaan yang sudah diajukan Pengawas Sekolah.',
    textColor: 'default',
    subtitleColor: 'subdued',
    ctaText: 'Periksa',
    ctaColor: 'black',
    path: '/penilai/perencanaan/daftar-ps',
  },
]

export const PERENCANAAN_PEJABAT_PENILAI_KINERJA_MENUS: TPenilaiPerencanaanMenu[] =
  [
    {
      key: 'not-submitted',
      title: 'Belum diajukan Pengawas Sekolah',
      subtitle: 'Kabari Pengawas Sekolah untuk segera mengajukan.',
      subtitleColor: 'subdued',
      textColor: 'default',
      ctaText: 'Cek daftar Pengawas Sekolah',
      ctaColor: 'white',
      path: '/penilai/perencanaan/daftar-ps/belum-diajukan',
    },
    {
      key: 'single-approval',
      title: 'Periksa satu per satu',
      subtitle: 'Periksa tiap perencanaan untuk setujui atau arahkan revisi.',
      textColor: 'default',
      subtitleColor: 'subdued',
      ctaText: 'Periksa satu per satu',
      ctaColor: 'black',
      path: '/penilai/perencanaan/daftar-ps',
    },
    {
      key: 'bulk-approval',
      title: 'Setujui sekaligus',
      subtitle:
        'Perencanaan yang sudah diperiksa Tim Kinerja dapat Anda setujui sekaligus.',
      textColor: 'default',
      subtitleColor: 'subdued',
      ctaText: 'Setujui Sekaligus',
      ctaColor: 'black',
      path: '/penilai/perencanaan/daftar-ps/setujui-sekaligus',
    },
  ]

export const PERENCANAAN_PENGEMBANGAN_KOMPETENSI_HINTS: Array<string> = [
  'Berdasarkan diskusi dengan Pengawas tentang fokus dan kemampuan selama 6 bulan ke depan',
  'Berdasarkan hasil Refleksi Kompetensi Pengawas',
]
